import initModal from './initializers/Modal.js'
import initUser from './initializers/User.js'
import initMcor2026Registration from './initializers/Mcor2026Registration.js'

const initApplication = () => {
  initModal()
  initUser()
  initMcor2026Registration()
}

export default initApplication
